import { ChevronLeft } from '@atom-learning/icons'
import * as React from 'react'

import { styled } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'
import { usePagination } from './usePagination'

const StyledActionIcon = styled(ActionIcon, {
  base: ['mr-1', 'disabled:opacity-30']
})

export const PaginationPreviousButton = (
  props: Partial<React.ComponentProps<typeof StyledActionIcon>>
) => {
  const { goToPreviousPage, labels, previousAvailablePage } = usePagination()

  const isDisabled = !previousAvailablePage

  return (
    <StyledActionIcon
      hasTooltip={false}
      size="md"
      theme="neutral"
      onClick={goToPreviousPage}
      disabled={isDisabled}
      {...props}
      label={labels?.previousPageButtonLabel || 'Previous page'}
    >
      <Icon is={ChevronLeft} />
    </StyledActionIcon>
  )
}
